import endpoints from '../endpoints.ts';
import {
  CustomerLocation,
  EpcisMedVocabulary,
  EpcisSgtin,
  OutboundDocument,
  OutboundDocumentEpcisSgtin,
  OutboundDocumentStatus,
  Toast,
  TradingPartner,
} from '../types/models.ts';
import { fetch } from './helpers.ts';

export namespace OutboundDocumentAPI {
  export namespace Request {
    export interface ReadManySearch {
      customerLocationId: string | number;
      tradingPartnerId?: string | number;
      ndc?: string;
      medName?: string;
      serialNumber?: string;
      dateSentStart?: string;
      dateSentEnd?: string;
    }

    export interface UpdateResendOneById {
      method: string;
      outboundDocumentId: number | string;
      recipientEmailAddresses?: string[];
    }
  }

  export namespace Response {
    export interface ReadManySearch extends OutboundDocument {
      customerLocation: CustomerLocation;
      tradingPartner: TradingPartner;
      outboundDocumentStatuses?: OutboundDocumentStatus[];
    }

    export interface ReadOneById extends ReadManySearch {
      outboundDocumentEpcisSgtins: (OutboundDocumentEpcisSgtin & {
        epcisSgtin: EpcisSgtin;
        epcisMedVocabulary: EpcisMedVocabulary;
      })[];
      outboundDocumentStatuses?: OutboundDocumentStatus[];
    }
  }
}

const outboundDocument = {
  read: {
    one: {
      by: {
        id: (
          outboundDocumentId: number | string
        ): Promise<OutboundDocumentAPI.Response.ReadOneById | null> => {
          const url = endpoints.outboundDocument.read.one.by.id();
          return fetch<OutboundDocumentAPI.Response.ReadOneById>(url, 'GET', {
            outboundDocumentId,
          });
        },
      },
    },
    many: {
      search: async (
        params: OutboundDocumentAPI.Request.ReadManySearch
      ): Promise<OutboundDocumentAPI.Response.ReadManySearch[] | null> => {
        const url = endpoints.outboundDocument.read.many.search();
        return await fetch<OutboundDocumentAPI.Response.ReadManySearch[]>(
          url,
          'GET',
          params
        );
      },
    },
  },
  update: {
    resend: {
      one: {
        by: {
          id: async (
            params: OutboundDocumentAPI.Request.UpdateResendOneById
          ) => {
            const url = endpoints.outboundDocument.update.resend.one.by.id();
            return await fetch<Toast>(url, 'PUT', params);
          },
        },
      },
    },
  },
  download: {
    one: {
      by: {
        id: async (outboundDocumentId: number | string): Promise<any> => {
          const url = endpoints.outboundDocument.download.one.by.id();
          return await fetch<any>(url, 'GET', { outboundDocumentId });
        },
      },
    },
  },
};

export default outboundDocument;
